export function createRectCache(element) {
    let current = element.getBoundingClientRect();
    const refresh = () => {
        current = element.getBoundingClientRect();
    };
    const observer = new ResizeObserver(refresh);
    observer.observe(element);
    window.addEventListener("resize", refresh, { passive: true });
    window.addEventListener("scroll", refresh, {
        capture: true,
        passive: true,
    });
    return {
        get current() {
            return current;
        },
        destroy() {
            observer.disconnect();
            window.removeEventListener("resize", refresh);
            window.removeEventListener("scroll", refresh, true);
        },
    };
}
// Source: Canvas UI rect cache, licensed under MIT + Commons Clause.
